'use client';
import { usePathname } from 'next/navigation';
import { LinkIcon as IconLink, ClipboardCopy as IconCopy } from 'lucide-react';

import showToast from '@/lib/showToast';

const NavMenuShare = () => {
  const shareLink = `https://chenook.com${usePathname()}`;

  const onShareClick = async () => {
    try {
      await navigator.clipboard.writeText(shareLink);
      showToast('Link copied to clipboard!', 'success', <IconCopy size={16} />);
    } catch {
      showToast('Failed to copy link to clipboard', 'error');
    }
  };

  return (
    <>
      <div className='hidden sm:flex items-center'>
        <div className='join'>
          <div>
            <label className='input join-item'>
              <IconLink size={14} />
              <p>{shareLink}</p>
            </label>
          </div>
          <button className='btn btn-neutral join-item' onClick={onShareClick}>
            Share
          </button>
        </div>
      </div>
    </>
  );
};

export default NavMenuShare;
